import {DaysOfWeek} from "./request";

const dayLabelsByLanguage: Record<string, { [key in DaysOfWeek]: string }> = {
    'nl': {
        [DaysOfWeek.Monday]: 'Ma',
        [DaysOfWeek.Tuesday]: 'Di',
        [DaysOfWeek.Wednesday]: 'Wo',
        [DaysOfWeek.Thursday]: 'Do',
        [DaysOfWeek.Friday]: 'Vr',
        [DaysOfWeek.Saturday]: 'Za',
        [DaysOfWeek.Sunday]: 'Zo',
    },
    'en': {
        [DaysOfWeek.Monday]: 'Mon',
        [DaysOfWeek.Tuesday]: 'Tue',
        [DaysOfWeek.Wednesday]: 'Wed',
        [DaysOfWeek.Thursday]: 'Thu',
        [DaysOfWeek.Friday]: 'Fri',
        [DaysOfWeek.Saturday]: 'Sat',
        [DaysOfWeek.Sunday]: 'Sun',
    },
};

export const getDaysOfWeekFormatted = (daysOfWeekArray: DaysOfWeek[], language: string): string => {
    const labels = dayLabelsByLanguage[language] ?? dayLabelsByLanguage['en'];

    return daysOfWeekArray
        .sort((a, b) => a - b)
        .map(day => labels[day])
        .map((label, index) =>
            index === 0 ? label.charAt(0).toUpperCase() + label.slice(1) : label.toLowerCase()
        )
        .join(', ');
};
